import { render, staticRenderFns } from "./hdqPagination.vue?vue&type=template&id=80ae6ce8&scoped=true&"
import script from "./hdqPagination.vue?vue&type=script&lang=js&"
export * from "./hdqPagination.vue?vue&type=script&lang=js&"
import style0 from "./hdqPagination.vue?vue&type=style&index=0&id=80ae6ce8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80ae6ce8",
  null
  
)

export default component.exports